import Tool, { type ToolArgs } from '../../../tools/Tool';
import React, { useState, useRef } from 'react';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import classNames from 'classnames';
import { isAttachmentElement } from '../../../types/guards';
import useFocusElementToolbarInput from '../../../components/ElementToolbar/useFocusElementToolbarInput';

const EditFileNameModal = ({ editor, element, toolbarHideModal }: ToolArgs) => {
  const defaultValue =
    element && isAttachmentElement(element)
      ? element.attachment_fileName ?? ''
      : '';
  const [originalValue] = useState(defaultValue);
  const [value, setValue] = useState(defaultValue);
  const inputRef = useRef<HTMLInputElement>(null);

  useFocusElementToolbarInput(inputRef);

  if (!element) return <></>;

  const path = ReactEditor.findPath(editor, element);

  const updateMediaElement = (fileName: string) => {
    Transforms.setNodes(
      editor,
      { attachment_fileName: fileName },
      {
        at: path,
      }
    );
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        toolbarHideModal?.();
        event.preventDefault();
        updateMediaElement(value);
        break;
      case 'Escape':
        toolbarHideModal?.();
        event.preventDefault();
        updateMediaElement(originalValue);
        break;
    }
  };

  const handleBlur = () => {
    updateMediaElement(value);
  };

  return (
    <div>
      <input
        type="text"
        ref={inputRef}
        className={classNames('unstyled-input', styles.toolbarInput)}
        placeholder="File name"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
      />
    </div>
  );
};

// Edit the fileName attribute of an attachment.
class ToolEditFileName extends Tool {
  static toolName = 'Edit file name';
  static iconClass = 'fa-regular fa-input-text';
  static withoutRefocus = true;

  // Show the modal view to editor the URL.
  static action({ editor, element, toolbarShowModal }: ToolArgs): void {
    toolbarShowModal?.(ToolEditFileName);
  }

  static renderToolbarButtonIcon() {
    return <span className={styles.toolbarButtonText}>Name</span>;
  }

  static renderToolbarModal(toolArgs: ToolArgs) {
    return EditFileNameModal(toolArgs);
  }

  static handleModalClosed({ editor, element }: ToolArgs) {}
}

export default ToolEditFileName;
